import { z } from 'zod';

export const ChainSchema = z.object({
  id: z.number().int().positive(),
  slug: z.string().min(1),
  name: z.string().min(1),
  chainId: z.number().int().positive(),
  family: z.string().min(1),
  nativeSymbol: z.string().min(1),
  nativeCoingeckoId: z.string().min(1).nullable(),
  explorerApi: z.string().url().nullable(),
  explorerUrl: z.string().url().nullable(),
  rpcUrl: z.string().url().nullable(),
  // Etherscan-compatible API base. NULL => global ETHERSCAN_BASE_URL default.
  apiBaseUrl: z.string().url().nullable(),
  enabled: z.boolean(),
});

export type ChainDto = z.infer<typeof ChainSchema>;

export const CreateChainRequestSchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(40)
    .regex(/^[a-z0-9-]+$/, 'slug must be lowercase letters, digits and dashes'),
  name: z.string().min(1).max(80),
  chainId: z.number().int().positive(),
  // Only evm-etherscan is wired today; reject other families until an adapter exists.
  family: z.literal('evm-etherscan'),
  nativeSymbol: z.string().min(1).max(12),
  nativeCoingeckoId: z.string().trim().min(1).max(128).nullable().optional(),
  explorerApi: z.string().url().nullable().optional(),
  explorerUrl: z.string().url().nullable().optional(),
  rpcUrl: z.string().url().nullable().optional(),
  apiBaseUrl: z.string().url().nullable().optional(),
  // CoinGecko asset-platform id (e.g. "ethereum", "arbitrum-one"); required for
  // token price enrichment on this chain. Without it, enrichment can't run.
  coingeckoPlatformSlug: z.string().min(1).max(64).nullable().optional(),
});

export type CreateChainRequest = z.infer<typeof CreateChainRequestSchema>;

export const UpdateChainRequestSchema = z
  .object({
    enabled: z.boolean().optional(),
    rpcUrl: z.string().url().optional(),
  })
  .refine((data) => data.enabled !== undefined || data.rpcUrl !== undefined, {
    message: 'Aucune modification fournie',
  });

export type UpdateChainRequest = z.infer<typeof UpdateChainRequestSchema>;
